
<div>
    <div class="grid grid-cols-1 mb-4">
        <spike-field-wrapper label="Cerca" labelFor="omnisearch_positionsfilters" >
            <input id="omnisearch_positionsfilters" placeholder="Cerca per commessa, posizione, referente etc.." pInputText [ngModel]="searchFilter().omnisearch" (ngModelChange)="updateFilter('omnisearch', $event)" class="w-full"/>
        </spike-field-wrapper>
        
        
    </div>
    <div class="flex " style="align-items:center">
        @for (item of workflowState().list; track $index) {
            <div class="mr-2">
                <p-button [label]="item.label" [severity]="subStateFilterId() == item.id ? 'info' : 'secondary'" styleClass="m-0" size="small" (click)="searchBySubState(item.id)" />
            </div>
        }
    </div>
</div>
